import { z } from 'zod';
import { LEVELS, ROLES, CATEGORIES, define, DEFINITION_KINDS } from '../types.js';

/**
 * Customer-specific radius in miles.
 */
export const schema = z.number().nonnegative();

export type CustomerServiceableRadiusMiles = z.infer<typeof schema>;

export const definition = define({
  key: 'customer_serviceable_radius_miles',
  schema,
  label: 'Customer Serviceable Radius Miles',
  description:
    'Used to validate move eligibility within the radius for clients who use our HopDrive Lite tier. Regions do not apply to these customers as they do not utilize our driver network.',
  kind: DEFINITION_KINDS.SETTING,
  category: CATEGORIES.SERVICE_RADIUS.key,
  writableAtLevels: [LEVELS.HOPDRIVE, LEVELS.CUSTOMER],
  readableByRoles: [ROLES.ADMIN],
  defaultValue: 100,
});
